import React from "react";

import InvoiceHeader from "./InvoiceHeader";
import InvoiceItems from "./InvoiceItems";
import InvoiceSummary from "./InvoiceSummary";
import Footer from "./Footer";

const InvoicePage = ({
    invoice,
    items,
    showSummary,
    pageNumber,
    totalPages
}) => {

    return (

        <div className="invoice-page">

            <div className="invoice-content">

                <InvoiceHeader invoice={invoice} />

                <InvoiceItems items={items} />

                {
                    showSummary &&
                    <InvoiceSummary invoice={invoice} />
                }

            </div>

            <Footer
                pageNumber={pageNumber}
                totalPages={totalPages}
            />

        </div>

    );

};

export default InvoicePage;